/* eslint-disable max-len */
/* eslint-disable newline-per-chained-call */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable nonblock-statement-body-position */
import { checkUserAct } from '@/api';
import { CouponBlackItem, CouponItemConfigItem, IPeriodCtrlConfig } from '@/types/config-type';
import { CouponState, ExActAndConfigCouponInfo, ExActAndCouponInfo } from '@/types/coupon';
import { IS_DEBUG, wait } from '@/utils';
import {
  checkIsDiscountCoupon,
  getAvailablePercent,
  getFormattedDiscount,
  isDayLimitCoupon,
  resloveCouponState,
  checkIsSpCoupon,
} from '@/utils/format-coupon';
import { CustomException, language } from '@tencent/ppd-base-libs';
import {
  AsyncExchangePrizeResult,
  CheckUserActRes,
  exchActPrizeInfo,
  ExchActPrizeInfoRes,
  exchangePrize,
  GoodItem,
  GoodsType,
  promShowGoodsInfo,
  qryExchangePrizeResult,
  QryExchangePrizeResultReq,
} from '@tencent/wphk-act-base-cgi';
import { to } from '@tencent/wphk-components-common/utils/common';
import dayjs from 'dayjs';
import compact from 'lodash/compact';
import { defineStore, storeToRefs } from 'pinia';
import { useConfigStore } from './config';
import { useStampStore } from './stamp';
import { useGrayStore } from './gray';
import { cacheFunc } from '@tencent/wphk-base-utils';
import { reportExchAction } from '@/hooks/use-exchange';
import { EventHookOn } from '@vueuse/core';
import { throwInterruptError } from '@/utils/interrupt';

export const useCouponStore = defineStore('coupon', {
  state: () => ({
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    exchActCouponInfo: {} as ExchActPrizeInfoRes,
    // 黑白名单不可用的券 id 列表
    invalidCpIdList: [] as string[],
    // 券列表
    cpList: [] as any[],
  }),
  getters: {
    formattedCouponList(state) {
      // 对券进行排序同时过滤被领完的券
      const filteredCouponList = rankCouponList(state.cpList).filter(coupon => coupon.couponState !== CouponState.end);
      return filteredCouponList;
    },
    /** 被领完的券列表 */
    couponStateEndList(state) {
      return rankCouponList(state.cpList).filter(coupon => coupon.couponState === CouponState.end);
    },
  },
  actions: {
    /** 初始化 */
    async initCouponInfo() {
      /**
       * 1. 拉券列表
       * 2. 拉黑白名单
       */
      await Promise.all([this.getCouponList(), this.getCouponBlackList()]);
      await this.handleFormatCpList();
    },
    // 整合券数据
    async handleFormatCpList() {
      // 1. 货源券配置
      const couponListConfig = this.getCouponListConfig();
      // 2. 后台兑换活动&券信息
      const formattedExchActCouponInfo = this.getFormattedExchActCouponInfo(couponListConfig);
      // 3. 整合后台+货源券配置
      const mergedCouponList = await this.getMergedCouponList(formattedExchActCouponInfo, couponListConfig);

      this.cpList = mergedCouponList;
    },
    /**
     * 货源券配置, 根据内测数据字段过滤 & 通过黑白名单过滤
     */
    getCouponListConfig() {
      const { couponConfig } = useConfigStore().config as IPeriodCtrlConfig;
      return couponConfig.couponListConfig.filter(
        (ele) => filterCouponByDebug(ele) && filterCouponByBlackList(ele, this.invalidCpIdList),
      );
    },
    /**
     * 格式化券兑换信息, 根据券状态过滤 & 根据货源券配置过滤
     * @param couponListConfig 货源券配置
     */
    getFormattedExchActCouponInfo(couponListConfig) {
      const stampStore = useStampStore();
      return formatExchActPrizeInfo(
        this.exchActCouponInfo as ExchActPrizeInfoRes,
        stampStore.remainCount,
      ).filter((ele) => filterCouponByCouponState(ele) && filterCouponByConf(ele, couponListConfig));
    },
    /**
     * 整合货源券配置 + 后台兑换活动券信息
     * @param formattedExchActCouponInfo 后台兑换活动券信息
     * @param couponListConfig 货源券配置
     */
    async getMergedCouponList(formattedExchActCouponInfo, couponListConfig) {
      const { isGrayUser } = storeToRefs(useGrayStore());
      if (!isGrayUser.value) {
        return mergeCouponConfig(formattedExchActCouponInfo, couponListConfig);
      }
      // 加密券 id
      const enCouponIdList = formattedExchActCouponInfo.map((coupon) => coupon.enCouponId);
      if (!enCouponIdList.length) {
        return [];
      }

      const couponListConfigByGood = await formatShowGoodsList(enCouponIdList);
      if (!couponListConfigByGood.length) {
        return [];
      }
      /**
       * 重复的字段
       * validExpireType === expireType（TODO:全量后干掉）
       * couponId === goodsId
       * enCouponId === goodsEnId
       */
      return mergeCouponConfig(formattedExchActCouponInfo, couponListConfig, couponListConfigByGood);
    },
    /**
     * 拉券列表
     */
    async getCouponList() {
      // 从配置中获取信息
      const { commonConfig } = useConfigStore().config as IPeriodCtrlConfig;
      const { stampId } = commonConfig.stampConfig;
      if (!stampId) throw new CustomException(stampId, 'eStampConfigStampIdEmpty', '新版狂赏印印花id为空');
      const stampIdDecodeVal = decodeURIComponent(stampId);

      const [err, result] = await to(exchActPrizeInfo({
        qualIdList: stampIdDecodeVal,
        statUserCpn: 1,
        qryQualAct: 1,
      }));
      if (err) return;
      // 查询优惠券兑换活动信息
      this.exchActCouponInfo = result;
    },
    /**
     * 拉黑白名单
     */
    async getCouponBlackList() {
      // 从配置中获取信息
      const { couponConfig } = useConfigStore().config as IPeriodCtrlConfig;
      const { couponBlackListConfig } = couponConfig;
      // 查券黑白名单
      const checkActList = getCheckActList(couponBlackListConfig);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [error, checkUserActRes] = await to(checkUserAct({ checkActList }));
      // 获取黑白名单不可用的券 id 列表
      this.invalidCpIdList = getInvalidCouponIdList(couponBlackListConfig, checkUserActRes);
    },
    /**
     * 用印花进行券兑换
     * @param qualId
     * @param actListid
     * @param prizeNo
     */
    async handleExchangePrize(prizeInfo: {
      qualId: string;
      actListid: string;
      prizeNo: string;
    }, onInterrupt?: EventHookOn<any>) {
      let isContiue = true;
      onInterrupt?.(() => { // 终止兑换流程
        isContiue = false;
      });
      const exchangeInfo = await exchangePrize({
        ...prizeInfo,
        isAsync: true,
      });
      const { exchangeListId } = exchangeInfo;
      reportExchAction({ action: 'afterSubmitAsyncExchange' });
      if (!exchangeListId) throw new Error('ExchangeListId not found');
      if (!isContiue) throwInterruptError('Exchange interrupt in handleExchangePrize');
      const exchangeResult = await qryExchangeResultLoop({
        actListid: prizeInfo.actListid,
        exchangeListId,
      }, onInterrupt);
      return exchangeResult;
    },
  },
});

/**
 * 循环查询异步兑换结果，每隔1s查一次，直至查到结果 或 查了10次
 */
async function qryExchangeResultLoop(req: QryExchangePrizeResultReq, onInterrupt?: EventHookOn<any>) {
  let exchangeResult = AsyncExchangePrizeResult.notFound;
  const MAX_RETRY_COUNT = 10;
  let qryCount = 0;
  let isInterrupt = false;
  // 如果终止兑换流程，则终止轮询
  onInterrupt?.(() => {
    isInterrupt = true;
  });
  do {
    qryCount += 1;
    const [err, res] = await to(qryExchangePrizeResult(req));
    reportExchAction({ action: `afterQueryAsyncExchange_${qryCount}` });
    if (!err) {
      exchangeResult = res.result;
    }
    if (exchangeResult === AsyncExchangePrizeResult.notFound) {
      await wait(1000);
    }
    if (isInterrupt) {
      throwInterruptError('Exchange interrupt in qryExchangeResultLoop');
    }
  } while (exchangeResult === AsyncExchangePrizeResult.notFound && qryCount < MAX_RETRY_COUNT);
  return exchangeResult;
}

/**
 * 对券进行排序
 * 券排序
 * 权重排序
 * @param list 券列表
 * @returns
 */
function rankCouponList(list: ExActAndConfigCouponInfo[]): ExActAndConfigCouponInfo[] {
  const enableList: any[] = []; // 可领取
  const unableList: any[] = []; // 印花不足
  const poverList: any[] = []; // 今日奖赏已领完
  const overList: any[] = []; // 已达兑换上限
  const otherList: any[] = []; // 可能没有

  for (const coupon of list) {
    // 排序
    if (coupon.couponState === CouponState.enable) {
      enableList.push(coupon);
    } else if (coupon.couponState === CouponState.unable) {
      unableList.push(coupon);
    } else if (coupon.couponState === CouponState.pover) {
      poverList.push(coupon);
    } else if (coupon.couponState === CouponState.over) {
      overList.push(coupon);
    } else {
      otherList.push(coupon);
    }
  }
  /**
   * 对优惠券列表进行排序
   * 按以下券状态排序：已解锁可兑换;已解锁印花数不足;（未解锁）;今日奖赏已领完;已达兑换上限;（已兑罄不展示）
   *
   */
  enableList.sort((one, two) => (one.sort < two.sort ? 1 : -1));
  unableList.sort((one, two) => (one.sort < two.sort ? 1 : -1));
  poverList.sort((one, two) => (one.sort < two.sort ? 1 : -1));
  overList.sort((one, two) => (one.sort < two.sort ? 1 : -1));
  otherList.sort((one, two) => (one.sort < two.sort ? 1 : -1));

  return enableList.concat(unableList).concat(poverList).concat(overList).concat(otherList);
}

/**
 * 根据内测数据字段过滤
 * @param coupon
 * @returns
 */
function filterCouponByDebug(coupon) {
  if (IS_DEBUG) return true;
  return coupon.status !== 'verifying';
}

/**
 * 根据券状态过滤
 * 过滤 expired已过期
 * 过滤 未开始券
 * 某一优惠券总库存消耗完（非日限额消耗完）时，该优惠券下线，不在页面显示
 * @param coupon
 * @returns
 */
function filterCouponByCouponState(coupon) {
  // 过滤 expired已过期
  if (coupon.couponState === CouponState.expired) return false;
  // 过滤 未开始券
  if (!coupon.exStartTime || !coupon.exSysTime || dayjs(coupon.exStartTime).isAfter(dayjs(coupon.exSysTime)))
    return false;
  // 非日限额消耗： 某一优惠券总库存消耗完（非日限额消耗完）时，该优惠券下线，不在页面显示
  // 日限额： 没有已兑罄，我们一般会每日均摊，库存消耗完的那一天就是优惠券下线的时间，所以没有已兑罄状态(日限额当天就是pover，最后是end)
  // if (coupon.couponState === CouponState.end) return false;
  return true;
}

/**
 * 通过黑白名单过滤
 * @param coupon 券
 * @param invalidCpIdList 黑白名单不可用的券 id 列表
 * @returns
 */
function filterCouponByBlackList(coupon, invalidCpIdList: string[]) {
  return !invalidCpIdList.includes(coupon.couponId);
}

/**
 * 通过货源券配置过滤券
 * @param coupon 后台返回的券
 * @param couponListConfig 货源券配置
 * @returns
 */
const filterCouponByConf = (coupon, couponListConfig: CouponItemConfigItem[] = []): boolean =>
  !!couponListConfig.find((item: CouponItemConfigItem) => item.couponId === coupon.couponId);

/**
 * 整合exchActPrizeInfo接口的返回
 * @param data 后台数据
 * @param remainStampCnt 剩余印花数
 * @returns
 */
const formatExchActPrizeInfo = (data: ExchActPrizeInfoRes, remainStampCnt: number): ExActAndCouponInfo[] => {
  const { sysTime } = data;
  const couponInfoList = data.couponInfoList || [];
  const exchActidList = data.qualExchActidList || [];
  const qualInfoList = data.qualInfoList || [];
  const couponList: ExActAndCouponInfo[] = [];
  /**
   * 1. 遍历券列表
   * 2. 通过prize_id 和 en_couponid找到对应的券信息
   */
  couponInfoList.forEach((coupon) => {
    const enExAct = exchActidList.find((act) => act.prizeId === coupon.enCouponid);
    const qualInfo = qualInfoList.find((item) => enExAct?.enActid === item.enActid);
    if (enExAct) {
      couponList.push({
        couponId: coupon.couponId || '', // 配置需要用到这个字段
        couponState: resloveCouponState(coupon, enExAct, sysTime, remainStampCnt),
        availablePercent: getAvailablePercent(enExAct),
        enCouponId: coupon.enCouponid,
        enExActId: enExAct.enActid || '',
        exQualCnt: enExAct.qualCnt || 0,
        exQualId: qualInfo?.qualId || '',
        exStartTime: enExAct.startTime,
        isDayLimitCoupon: isDayLimitCoupon(enExAct),
        exSysTime: sysTime,
      });
    }
  });
  return couponList;
};

const cachePromShowGoodsInfo = cacheFunc(promShowGoodsInfo);
/** 获取并格式化promShowGoodsInfo返回 */
const formatShowGoodsList = async (enCouponIdList: string[]) => {
  // 因为这个数据一般不会变化，所以做了优化，进行 session 缓存，减少用户操作后的重复请求
  const [err, couponListConfigByGood] = await to(
    cachePromShowGoodsInfo({
      goodsType: GoodsType.coupon,
      goodsIdList: enCouponIdList,
    }),
  );
  if (err) {
    return [];
  }
  return (couponListConfigByGood.goodsArr || []).map((ele) => ({
    ...ele,
    couponId: ele.goodsId, // 因为删不掉 goodsId，所以会有重复，TODO:全量后处理
    validExpireType: ele.expireType, // 同上
  }));
};

/*
 * 整合券配置
 */
// eslint-disable-next-line max-len
const mergeCouponConfig = (
  couponList: ExActAndCouponInfo[],
  couponListConfig: CouponItemConfigItem[] = [],
  couponListConfigByGood: GoodItem[] = [],
): any[] => {
  const filteredCouponList = compact(
    couponList.map((coupon: ExActAndCouponInfo) => {
      /**
       * 券配置有三种来源：
       * 1. 货源券配置
       * 2. 接口券静态配置（含有 mojo 上券相关的多语言配置） prom_show_goods_info.cgi
       * 3. 接口券动态配置（含有券和活动相关配置） exch_act_prize_info.cgi
       */
      // 根据couponId找出券配置中存在的券
      const couponConf = couponListConfig.find((item: CouponItemConfigItem) => item.couponId === coupon.couponId);
      // 根据couponId找出后台接口物品信息中的券
      const couponConfGood = couponListConfigByGood.find((item) => item.goodsId === coupon.couponId);
      if (couponConf) {
        const couponType = couponConfGood?.couponType || couponConf.couponType;
        const isSpCoupon = checkIsSpCoupon(couponType);
        const isDiscountCoupon = checkIsDiscountCoupon(couponType);
        const discount = getFormattedDiscount(
          couponConfGood?.discount || couponConf.discount,
          couponType,
          language.getLanguage(),
        );
        // console.log('***couponConf: ', JSON.stringify(couponConf));
        // console.log('***couponConfGood: ', JSON.stringify(couponConfGood));
        // console.log('***couponResult', JSON.stringify({
        //   ...couponConf,
        //   ...couponConfGood,
        //   ...coupon,
        //   isSpCoupon,
        //   isDiscountCoupon,
        //   discount,
        // }));
        return {
          ...couponConf,
          ...couponConfGood,
          ...coupon,
          isSpCoupon,
          isDiscountCoupon,
          discount,
        };
      }
      return undefined;
    }),
  );
  return filteredCouponList;
};

/**
 * 从配置中获取黑白名单数据
 * @param couponBlackListConfig 券黑白名单配置
 * @returns
 */
function getCheckActList(couponBlackListConfig: CouponBlackItem[]) {
  return couponBlackListConfig.map((item) => ({
    actListid: item.blackListActId,
    checkType: item.blackListType,
  }));
}

/**
 * 获取黑白名单不可用的券 id 列表
 * @param couponBlackListConfig 黑白名单配置
 * @param checkUserActRes 黑白名单后台数据
 * @returns
 */
function getInvalidCouponIdList(couponBlackListConfig: CouponBlackItem[], checkUserActRes: CheckUserActRes): string[] {
  const couponIds: string[] = [];
  for (const conf of couponBlackListConfig) {
    const userActInfo = (checkUserActRes?.userActInfoList || []).find(
      (userActInfo) => userActInfo.actListid === conf.blackListActId,
    );
    /**
     * 不可用的条件
     * 1. 黑白名单接口报错
     * 2. 如果是活动未开始或已结束
     * 3. 如果是不可用（不在白名单或者在黑名单）
     */
    if (!checkUserActRes || userActInfo?.isExpired || !userActInfo?.isValid) {
      couponIds.push(conf.couponId);
    }
  }
  return couponIds;
}
